import { Injectable } from '@angular/core';
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateChild,
	CanLoad,
	Route,
	UrlSegment,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TeamValidationGuard implements CanActivate, CanActivateChild, CanLoad {
	constructor(private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.validateTeamAccess(route);
	}

	canActivateChild(
		childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.validateTeamAccess(childRoute);
	}

	canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
		if (segments.length > 0) {
			const teamFromUrl = segments[0].path;
			const isValid = this.validateTeamFromSubdomain(teamFromUrl);
			if (isValid instanceof UrlTree) {
				this.router.navigateByUrl(isValid);
				return false;
			}
			return isValid;
		}
		return true;
	}

	private validateTeamAccess(route: ActivatedRouteSnapshot): boolean | UrlTree {
		const teamFromUrl = route.paramMap.get('team') || (route.parent && route.parent.paramMap.get('team'));
		
		if (!teamFromUrl) {
			return true;
		}

		return this.validateTeamFromSubdomain(teamFromUrl);
	}

	private validateTeamFromSubdomain(teamFromUrl: string): boolean | UrlTree {
		try {
			const hostname = window.location.hostname;
			
			const subdomainMatch = hostname.match(/^([^.]+)\./);
			const subdomain = subdomainMatch ? subdomainMatch[1] : null;
			
			if (!subdomain) {
				return true;
			}

			if (subdomain.toLowerCase() === teamFromUrl.toLowerCase()) {
				return true;
			}

			return this.router.parseUrl('/404');
			
		} catch (error) {
			console.error('Error validating team access:', error);
			return true;
		}
	}
}
